fx.ns("desktop.poster", class PosterMain extends shared.BaseMain {

	constructor() {
		super(new repositories.PosterRepository());

        this.model.layoutid = this.layoutid;
		fx.set("app", "poster");
	}

	init() {
		this.views = ["desktop.common.screens.Splash",
			"shared.screens.Saving",
			"desktop.common.photoimport.UploadProgress",
			"shared.screens.UpsellFirstScreen",
			"shared.screens.UpsellSecondScreen",
			"desktop.common.panels.SelectPhotosPanel",
			"desktop.poster.PosterEditor",
			"desktop.poster.PhotoChoices",
			"shared.screens.PosterSizeScreen",
            "shared.screens.PosterFinitionScreen",
            "shared.screens.RemotePhotoEffectWaiting",
		];

		fx.enableToolTip();
		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}

    get layoutid() {
		return this.secondUrlParameter || this.model.layout;
	}

	onDataEvent(e) {
		super.onDataEvent(e);

		switch (e.type) {
			case "start":
				if (this.model.creationid) {
					if (this.previewMode)
						this.steps({ view: "Splash", skipPrevious: true }, "UpsellFirstScreen"); // ajouter editeur
					else
						this.steps({ view: "Splash", skipPrevious: true }, "PosterEditor");
				}
				else {
					let steps = [{ view: "Splash", skipPrevious: true }];
					fx.set("mode", "creating");

                    // poster from an ai picture : let user select a picture
                    if (this.model.hasFilteredPhoto)
                    {
                        steps.push("PhotoChoices");
                        steps.push("RemotePhotoEffectWaiting");
                    }

                    
					steps.push("PosterEditor");

					this.steps(steps);
				}
				break;

			case "upload-progress":
				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

			case "frame-choice":
					this.switchTo("PosterFinitionScreen");
                    break;
                
            case "size-choice":
					this.switchTo("PosterSizeScreen");
				break;

            case "wall-preview":
                this.popup(new shared.popups.WallPreviewPopup(this.model));
                break;

			case "order":
                // ordering is a commitment : the creation has to exist in the account even if the
                // client changed nothing, or the night cleaning takes its photos
                this.model.undelete();

                // from the editor, the Aperçu 3D in every case : the finish and the size are chosen
                // there, the upsell screens are not shown any more ; its own "Commander" comes back
                // here with choicesMade and goes to the order. Remembered : BaseMain sends "order"
                // again on its own, plain, once the creation is saved or the customer registered,
                // and that one must go on to the order rather than open the preview again
                if (e.detail && e.detail.choicesMade)
                    this._orderConfirmed = true;

                if (!this._orderConfirmed)
                {
                    this.popup(new shared.popups.WallPreviewPopup(this.model));
                    break;
                }

                if (this.readyLeaving(e.type))
                {
                    this.actionRequested = "";
                    this.model.event("navigate-order");
                }
                break;

            // not registered after all : the next "Commander" shows the preview again
            case "refused-register":
                if (!this.model.account.isRegistered)
                    this._orderConfirmed = false;
                break;

			case "no-upsell-available":
				if (this.readyLeaving(e.type))
					this.model.event("navigate-order");
				break;

			case "upsell-selected":
				if (this.readyLeaving(e.type))
					this.model.event("navigate-order");
				break;

			case "exit-editor":
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit");
				break;

            case "apply-effect" :
            case "filtering-photo" :
                    this.switchTo("RemotePhotoEffectWaiting");
                break;

            case "effect-applied":
                    this.switchTo("PosterEditor");
                break;

			case "selectphotos":
				if (this._skipReopenAfterPdf)
				{
					this._skipReopenAfterPdf = false;
					break;
				}
				this.switchTo("PhotoChoices", {model : this.model, component : e.detail});
				break;

			// Every import uses the shared SelectPhotosPanel. The AI "filtered photo" flow overrides the
			// panel's validate action : instead of the standard import, validating (Importer) applies
			// the AI effect to the received photo (see the apply-filtered-photo case below).
			case "import-mobile":
				if (this.model.hasFilteredPhoto)
					this._startMobileImport({ validateEvent : "apply-filtered-photo" });
				else
					this._startMobileImport();
				break;

			// validated on the SelectPhotosPanel : the photos are already in the album
			case "google-photos-added":
				this.model.event("show-editor");
				break;

			case "import-google":
				this.popup(new desktop.common.photoimport.GooglePanel(this.model));
				break;

			case "file-uploading":
				this._skipReopenAfterPdf = true;
				this.popup(new shared.popups.ConversionPdfFiles(e.model));
				break;

			case "file-uploaded":
				this.popup(new shared.popups.FileUploaded());
				break;

			case "file-already-processing":
				this.popup(new shared.popups.FileAlreadyProcessing(this.model));
				break;

			case "file-upload-failed":
				this.popup(new shared.popups.FileUploadFailed(this.model));
				break;

			// make sure the receiving screen is up and the phone popup is closed (every flow)
			case "mobile-upload-started":
			case "mobile-upload-send":
				this._showMobileImport();
				break;

			case "show-editor":
				this.actionRequested = ""
				this.switchTo("PosterEditor");
				break;

			case "screen-saving":
				this.switchTo("Saving");
				break;

            // AI "filtered photo" flow : the user validated the received photo (Importer). Apply the
            // effect to it, which switches to RemotePhotoEffectWaiting. (Every other import lets the
            // SelectPhotosPanel own "done" via the standard import-photos-validated flow.)
            case "apply-filtered-photo":
                fx.service("SmsService").stop();
                this.popup(null);
                this.model.creation.filteredPhoto.content = this.model.photos.last.id;
                this.model.photos.last.event("apply-effect", {effect : this.model.creation.filteredPhoto.content_type, imageWidth : this.model.creation.filteredPhoto.width, imageHeight : this.model.creation.filteredPhoto.height});
                break;

		}
	}

	_toggleGridMode(e) {
		fx.get("settings").toggleGridMode();

		e.stopPropagation();
		e.preventDefault();
	}

});